import { makeStyles } from "@material-ui/core/styles";
import { CenterFocusStrong } from "@material-ui/icons";
import myTheme from "../../themes/palette";
// require('../../themes/fonts')
const useStyles = makeStyles((theme) => {
  return {
    page: {
      //background:'#fafafa',
      // width: "100%",
      // height: "100%",
      //padding: theme.spacing(3)
      marginTop:126,
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        marginTop:164,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        marginTop:160,
      },
    },
    
  };
});

export default useStyles;
